import * as queries from "./query";
import * as mutations from "./mutation";

import RootStore from "@services";

export default new RootStore({ queries, mutations });
